export const basic = {
  estimate_date: {
    label: 'Estimate Date',
    placeholder: 'Add estimate date',
    dateFormat: 'MM-DD-YYYY',
    utc: true,
    timeFormat: false,
    input: true,
    viewMode: 'days',
    system: {
      name: 'estimate',
    },
    value: '',
    errors: [],
    type: 'text',
    name: 'estimate_date',
    rules: {
      title: 'Estimate date field',
      required: true,
    }
  },
  status: {
    label: 'Quote Status',
    placeholder: 'Add quote status',
    system: {
      name: 'status',
    },
    value: '',
    errors: [],
    type: 'text',
    name: 'status',
    rules: {
      title: 'Quote status field',
      required: true,
    }
  },
  name: {
    label: 'Name',
    placeholder: 'Add name',
    system: {
      name: 'name',
    },
    value: '',
    errors: [],
    type: 'text',
    name: 'name',
    rules: {
      title: 'Name field',
      required: true,
    }
  },
  description: {
    label: 'Description',
    placeholder: 'Add description',
    system: {
      name: 'description',
    },
    value: '',
    errors: [],
    type: 'text',
    name: 'description',
    rules: {
      title: 'Description field',
      required: true,
    }
  },
  subtotals: {
    label: 'Subtotals',
    system: {
      name: 'subtotals',
    },
    value: '',
    errors: [],
    type: 'text',
    name: 'subtotals',
    rules: {
      title: 'Content field',
    },
    helper: 'Press Tab to add new subtotal row or right-click to new rows and columns',
  },
  total_amount: {
    prefix: '$',
    label: 'Total Amount',
    placeholder: 'Add total amount',
    system: {
      name: 'total_amount',
    },
    value: '',
    errors: [],
    type: 'text',
    name: 'total_amount',
    rules: {
      title: 'Total amount field',
      required: true,
    }
  },
  amount_tbd: {
    label: 'To be discussed',
    system: {
      name: 'amount_tbd'
    },
    value: false,
    errors: [],
    type: 'text',
    name: 'amount_tbd',
    rules: {}
  },
  customer: {
    label: 'Customer',
    placeholder: 'Add customer',
    system: {
      name: 'project_id',
    },
    value: '',
    errors: [],
    type: 'text',
    name: 'customer',
    rules: {
      title: 'Customer field',
      required: true,
    }
  },
  contacts: {
    label: 'Customer contacts',
    placeholder: 'Select contacts',
    system: {
      name: 'contacts',
    },
    value: [],
    errors: [],
    type: 'text',
    name: 'contacts',
    rules: {
      title: 'Customer contacts field',
      required: false
    }
  },
  scope_of_work: {
    label: 'Scope of Work',
    placeholder: 'Add content',
    system: {
      name: 'scope_of_work',
    },
    value: '',
    errors: [],
    type: 'text',
    name: 'scope_of_work',
    rules: {
      title: 'Content field',
    },
    helper: 'Press Enter to add new paragraph or Shift+Enter to add new line inside of a paragraph',
  },
  sales_rep: {
    label: 'Sales Rep',
    placeholder: 'Choose sales rep',
    system: {
      name: 'sales_rep_id',
    },
    value: '',
    errors: [],
    type: 'text',
    name: 'sales_rep_id',
    rules: {
      title: 'Sales Rep field',
      required: false,
    }
  },
};



// WEBPACK FOOTER //
// ./src/containers/QuotesEdit/fields.js